// extracted by mini-css-extract-plugin
export default {"inputGroup":"LatestResults_inputGroup__1N1B6"};